import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import moment from 'moment'

interface AdminSchool {
  name: string | null
  id: number | null
  city: string | null
  state: string | null
  street: string | null
  country?: string | null
  startDate: string | null
  districtName: string | null
  type: string | null
  notes: string | null
  timezone: string | null
  isQASchool: boolean | null
}

export const selectSchools = (state: any) => state.schools
export const selectSchool = (id: number) => (state: any) => state.schools.find((school: AdminSchool) => school.id === id)

const initialState: AdminSchool[] = [{
  name: null,
  id: null,
  city: null,
  state: null,
  street: null,
  startDate: null,
  districtName: null,
  type: null,
  notes: null,
  timezone: null,
  isQASchool: null,
}]

const schoolsSlice = createSlice({
  name: 'schools',
  initialState,
  reducers: {
    loadSchools: (state, {
      payload: schools,
    }: PayloadAction<any[]>) => schools.map((school: any) => ({
      name: school.name,
      id: school.id,
      city: school.city,
      state: school.state,
      street: school.street,
      country: school.country,
      districtName: school.districtName,
      type: school.type,
      notes: school.note,
      timezone: school.timezone,
      startDate: school.startDate ? moment(school.startDate).format('YYYY-MM-DD') : null,
      isQASchool: school.isQASchool
    })),
  },
})

export const { loadSchools } = schoolsSlice.actions

export default schoolsSlice.reducer
